// extracted by mini-css-extract-plugin
export default {"summaries":"styles_summaries__vzVyf","collapse":"styles_collapse__dPOC8","btnWrapper":"styles_btnWrapper__ARl0d","counter":"styles_counter__jbKUb"};